var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 183",
    width: 82,
    height: 183,
    fill: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.815 183h1.298c14.934-24.977 22.888-37.71 35.387-50.607H55.69v.817c12.175 1.306 2.435 26.119-10.875 49.79Zm-7.143-69.054C46.762 64.809 54.23 30.201 50.983 0h28.57C60.235 28.078 50.657 64.483 38.321 113.946h-.65ZM26.634 0h-.811S16.245 60.891.5 133.21h52.106v-.817C13.486 131.087 17.706 70.523 26.634 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.680898c22f7dfd0b031403bf3a6179c7.svg";
export { ForwardRef as ReactComponent };